export const appNameConstants = Object.freeze({
  CLIENT_PORTAL: 'CLIENT_PORTAL',
  CUSTOMER_PORTAL: 'CUSTOMER_PORTAL',
})
